import React, { useState, useEffect } from 'react';
import { Typography, Grid, Button, Accordion, AccordionSummary, AccordionDetails, List, ListItemText, Divider } from '@mui/material';
import { myApi } from '../../../config/axiosConfig';
import useMediaQuery from '@mui/material/useMediaQuery';
import Swal from 'sweetalert2';

// Iconos
import AddCircleIcon from '@mui/icons-material/AddCircle';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

// Componentes
import CrearEditarPerfilModal from './modales/CrearEditarPerfilModal';

const Perfiles = () => {
    const isNonMobile = useMediaQuery("(min-width:600px)");
    const [data, setData] = useState([]);
    const [selectedProfile, setSelectedProfile] = useState(null);
    const [modalOpen, setModalOpen] = useState(false);
    const [isEditing, setIsEditing] = useState(false);

    const fetchProfiles = async () => {
        try {
            const response = await myApi.get('/perfiles');
            setData(response.data.data);
        } catch (error) {
            console.error('Error fetching profiles:', error);
        }
    };

    const handleOpenModal = (profile = null) => {
        setSelectedProfile(profile);
        setIsEditing(!!profile);
        setModalOpen(true);
    };

    const handleDelete = async (id) => {
        console.log('Deleting profile:', id);
        try {
            let {data} = await myApi.delete(`/perfiles/eliminar/${id}`);

            if (data.success){
                Swal.fire({
                    icon: 'success',
                    title: 'Perfil eliminado',
                });
            }else{
                Swal.fire({
                    icon: 'error',
                    title: 'Error al eliminar el perfil',
                });
            }
            fetchProfiles();
        } catch (error) {
            console.error('Error deleting profile:', error);
        }
    };

    useEffect(() => {
        fetchProfiles();
    }, []);

    return (
        <Grid container spacing={2} direction="column">
            <Grid item xs={12}>
                <Typography variant="h4" fontWeight="bold" marginBottom={2}>
                    Perfiles
                </Typography>
            </Grid>
            <Grid item xs={12} sx={{ display: 'flex', justifyContent: isNonMobile ? 'flex-end' : 'start' }}>
                <Button
                    variant="contained"
                    startIcon={<AddCircleIcon />}
                    onClick={() => handleOpenModal()}
                    sx={{ backgroundColor: 'black', marginBottom: 1 }}
                >
                    Agregar Perfil
                </Button>
            </Grid>
            {data.map((profile) => (
                <Grid item xs={12} key={profile.id_perfil}>
                    <Accordion>
                        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                            <Typography>{profile.nombre_perfil}</Typography>
                        </AccordionSummary>
                        <Divider />
                        <AccordionDetails>
                            <Typography variant="h6">Modulos asociados al perfil:</Typography>
                            <List>
                                {profile.modulos.map((module) => (
                                    <ListItemText key={module.id_modulo} primary={module.nombre_modulo} />
                                ))}
                            </List>
                            <Button size="small" onClick={() => handleOpenModal(profile)}>Editar</Button>
                            <Button
                                size="small"
                                color="error"
                                onClick={() => handleDelete(profile.id_perfil)}
                            >
                                Eliminar
                            </Button>
                        </AccordionDetails>
                    </Accordion>
                </Grid>
            ))}
            <CrearEditarPerfilModal
                open={modalOpen}
                onClose={() => setModalOpen(false)}
                refresh={fetchProfiles}
                profile={selectedProfile}
                isEditing={isEditing}
            />
        </Grid>
    );
};

export default Perfiles;
